/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Role data transfer object with protection status and audit information
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    _protected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    systemRole?: boolean;
    /**
     * Unique role identifier
     * @type {string}
     * @memberof RoleDto
     */
    id?: string;
    /**
     * Role name
     * @type {string}
     * @memberof RoleDto
     */
    name?: string;
    /**
     * Human-readable display name
     * @type {string}
     * @memberof RoleDto
     */
    displayName?: string;
    /**
     * Role description
     * @type {string}
     * @memberof RoleDto
     */
    description?: string;
    /**
     * List of permissions granted to this role
     * @type {Array<string>}
     * @memberof RoleDto
     */
    permissions?: Array<string>;
    /**
     * Tenant ID this role belongs to
     * @type {string}
     * @memberof RoleDto
     */
    tenantId?: string;
    /**
     * Tenant name this role belongs to
     * @type {string}
     * @memberof RoleDto
     */
    tenantName?: string;
    /**
     * Tenant slug this role belongs to
     * @type {string}
     * @memberof RoleDto
     */
    tenantSlug?: string;
    /**
     * Customer ID associated with the tenant
     * @type {string}
     * @memberof RoleDto
     */
    customerId?: string;
    /**
     * Customer name associated with the tenant
     * @type {string}
     * @memberof RoleDto
     */
    customerName?: string;
    /**
     * Whether the role is active
     * @type {boolean}
     * @memberof RoleDto
     */
    active?: boolean;
    /**
     * Whether this role is protected from deletion
     * @type {boolean}
     * @memberof RoleDto
     */
    isProtected?: boolean;
    /**
     * Whether this is a system-built-in role
     * @type {boolean}
     * @memberof RoleDto
     */
    isSystemRole?: boolean;
    /**
     * When the role was created
     * @type {Date}
     * @memberof RoleDto
     */
    created?: Date;
    /**
     * When the role was last updated
     * @type {Date}
     * @memberof RoleDto
     */
    updated?: Date;
    /**
     * User ID who created this record
     * @type {string}
     * @memberof RoleDto
     */
    createdByUserId?: string;
    /**
     * Username who created this record
     * @type {string}
     * @memberof RoleDto
     */
    createdByUsername?: string;
    /**
     * User ID who last updated this record
     * @type {string}
     * @memberof RoleDto
     */
    updatedByUserId?: string;
    /**
     * Username who last updated this record
     * @type {string}
     * @memberof RoleDto
     */
    updatedByUsername?: string;
    /**
     * When this record was last updated (UTC)
     * @type {Date}
     * @memberof RoleDto
     */
    updatedAt?: Date;
    /**
     * When this record was created (UTC)
     * @type {Date}
     * @memberof RoleDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the RoleDto interface.
 */
export function instanceOfRoleDto(value: object): value is RoleDto {
    return true;
}

export function RoleDtoFromJSON(json: any): RoleDto {
    return RoleDtoFromJSONTyped(json, false);
}

export function RoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_protected': json['protected'] == null ? undefined : json['protected'],
        'systemRole': json['systemRole'] == null ? undefined : json['systemRole'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'tenantSlug': json['tenantSlug'] == null ? undefined : json['tenantSlug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'active': json['active'] == null ? undefined : json['active'],
        'isProtected': json['isProtected'] == null ? undefined : json['isProtected'],
        'isSystemRole': json['isSystemRole'] == null ? undefined : json['isSystemRole'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'createdByUserId': json['createdByUserId'] == null ? undefined : json['createdByUserId'],
        'createdByUsername': json['createdByUsername'] == null ? undefined : json['createdByUsername'],
        'updatedByUserId': json['updatedByUserId'] == null ? undefined : json['updatedByUserId'],
        'updatedByUsername': json['updatedByUsername'] == null ? undefined : json['updatedByUsername'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function RoleDtoToJSON(json: any): RoleDto {
    return RoleDtoToJSONTyped(json, false);
}

export function RoleDtoToJSONTyped(value?: RoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protected': value['_protected'],
        'systemRole': value['systemRole'],
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'permissions': value['permissions'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'tenantSlug': value['tenantSlug'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'active': value['active'],
        'isProtected': value['isProtected'],
        'isSystemRole': value['isSystemRole'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'createdByUserId': value['createdByUserId'],
        'createdByUsername': value['createdByUsername'],
        'updatedByUserId': value['updatedByUserId'],
        'updatedByUsername': value['updatedByUsername'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

